import { v4 as uuidv4 } from "uuid";
import type { BaseBlock } from "@circle-react-shared/BuilderUI/DataModel.types";
import {
  ContentProp,
  CornersProp,
  DesignProp,
  GeneralProp,
  MarginsProp,
  PaddingsProp,
  SizingProp,
} from "@circle-react-shared/BuilderUI/constants/PropCategories";
import {
  getMarginOptions,
  getPaddingOptions,
} from "@circle-react-shared/BuilderUI/utils/boxModelStyleHelpers";
import {
  getBorderRadiusOptions,
  getImageOpacityOptions,
  getObjectFitOptions,
  getObjectPositionOptions,
} from "@circle-react-shared/BuilderUI/utils/imgStyleHelpers";
import { getSizingOptions } from "@circle-react-shared/BuilderUI/utils/sizeStyleHelpers";
import { defaultStyles } from "./defaultStyles";

export const defaultData: BaseBlock = {
  id: uuidv4(),
  type: "img",
  meta: {},
  props: {
    image: {
      prop: "other",
      type: "circle-image-upload",
      value: {
        signed_id: null,
      },
      meta: {
        name: "Image",
        nameI18n: "builder_ui.prop_type.image.image",
        category: [ContentProp],
      },
    },
    alt: {
      prop: "other",
      type: "string",
      value: "",
      meta: {
        name: "Alt text",
        nameI18n: "builder_ui.prop_type.image.alt_text",
        category: [ContentProp],
      },
    },
    styles: {
      prop: "styles",
      type: "styles",
      value: {
        objectFit: getObjectFitOptions({
          defaultValue: defaultStyles.objectFit,
          category: [DesignProp, GeneralProp],
        }),
        objectPosition: getObjectPositionOptions({
          defaultValue: defaultStyles.objectPosition,
          category: [DesignProp, GeneralProp],
        }),
        opacity: getImageOpacityOptions({
          defaultValue: defaultStyles.opacity,
          category: [DesignProp, GeneralProp],
        }),
        borderRadius: getBorderRadiusOptions({
          defaultValue: defaultStyles.borderRadius,
          category: [DesignProp, CornersProp],
        }),
        sizing: getSizingOptions({
          defaultValue: defaultStyles.sizing,
          category: [DesignProp, SizingProp],
        }),
        padding: getPaddingOptions({
          defaultValue: defaultStyles.padding,
          category: [DesignProp, PaddingsProp],
        }),
        margin: getMarginOptions({
          defaultValue: defaultStyles.margin,
          category: [DesignProp, MarginsProp],
        }),
      },
      meta: {
        name: "Styles",
        nameI18n: "builder_ui.prop_type.styles.title",
        category: [DesignProp],
      },
    },
  },
};
